import { InviteSearch } from "#webapp/src/components/invite-search";
import React from "react";
import { BulkInviteEvent, InviteSearchPerson } from "../../../invite-search";
import { useBulkInvite } from "../../../invite-search/hooks/useBulkInvite";
import { useInviteSuggestions } from "../../../invite-search/hooks/useInviteSuggestions";
import { Header, Loading, SlideLayout, Text } from "../../shared-components";
import { IconVariant } from "../../shared-components/Header";
import { setError } from "../../utils/setError";

export const InviteSlide = ({
  onCheck,
  selectedInvitees,
}: {
  onCheck: (
    invitees: InviteSearchPerson[],
    checked: boolean,
    bulkInviteEvent?: BulkInviteEvent,
  ) => void;
  selectedInvitees: InviteSearchPerson[];
}) => {
  const { suggestions, loading: suggestionsLoading } = useInviteSuggestions((error) =>
    setError({
      message: "failed to gather invite suggestions",
      error: error,
      showUserMessage: false,
    }),
  );

  const { events, loading: bulkLoading } = useBulkInvite((error) =>
    setError({
      message: "failed to gather bulk invite suggestions",
      error: error,
      showUserMessage: false,
    }),
  );

  const loading = suggestionsLoading || bulkLoading;

  return loading ? (
    <Loading />
  ) : (
    <SlideLayout>
      <Header iconVariant={IconVariant.Line}> Experience the power with your team </Header>
      <Text>
        When everyone you meet with is using Clockwise, it increases the likelihood of finding a
        better time for your meetings.
      </Text>
      <div className="cw-w-full md:cw-w-[600px] cw-mt-8">
        <div className="cw-heading-sm cw-mb-2">Invite teammates </div>
        <InviteSearch
          selectedInvitees={selectedInvitees}
          suggestions={suggestions}
          onCheck={onCheck}
          bulkInviteEvents={events}
          trackingVariant="Onboarding"
        />
      </div>
    </SlideLayout>
  );
};
